import React from "react";
import { useTranslation } from "react-i18next";
import { SubPage, FullDivider } from "./SubPage";

export function Stack() {
  const { t } = useTranslation("stack");
  const categories = t("categories", { returnObjects: true }) as { name: string; tools: { name: string; desc: string }[] }[];

  return (
    <SubPage title={t("title")} subtitle={t("subtitle")}>
      {categories.map((cat) => (
        <div key={cat.name}>
          <div className="px-5 sm:px-8 md:px-[66px] pt-10 md:pt-12 pb-3">
            <h2 className="text-lg font-semibold text-white">{cat.name}</h2>
          </div>
          <FullDivider />
          <div className="grid grid-cols-1 md:grid-cols-2 gap-px bg-grey-800">
            {cat.tools.map((tool) => (
              <div key={tool.name} className="bg-grey-975 px-5 sm:px-8 md:px-[66px] py-4 md:py-5 flex items-baseline gap-3">
                <span className="text-sm text-white/70 font-medium shrink-0" style={{ fontFamily: "'Space Mono', monospace" }}>
                  {tool.name}
                </span>
                <span className="text-xs text-white/25">{tool.desc}</span>
              </div>
            ))}
          </div>
          <FullDivider />
        </div>
      ))}
    </SubPage>
  );
}
